// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { PagerSettings } from "../flow/types";
import type { Action } from "../flow/types";

export default function(
  state: PagerSettings = initialState.pager,
  action: Action
) {
  switch (action.type) {
    case ActionTypes.SET_PAGER:
      return action.payload;
    case ActionTypes.SET_ACTIVE_PAGE:
      return { ...state, activePage: action.payload };
    default:
      return state;
  }
}
